import { useState, useEffect, useCallback } from 'react'

import { useRefundsModal } from './useRefundsModal'
import { mySalesService } from '../Services/mySalesService'

export const usePaymentsInformation = () => {
  const [paymentsInformation, setPaymentsInformation] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const { refundsState, openRefundsModal, closeRefundsModal } = useRefundsModal()

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await mySalesService.getPaymentsInfo()
        setPaymentsInformation(data)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchPayments()
  }, [])

  const handleRefundsClick = useCallback((e, refundIds) => {
    e.preventDefault()
    openRefundsModal(refundIds)
  }, [openRefundsModal])

  return {
    paymentsInformation,
    isLoading,
    error,
    refundsState,
    handleRefundsClick,
    handleCloseRefundsModal: closeRefundsModal,
  }
}
